
$(document).ready(function(){

    // scroller js 

       $(".itg_slider_button ").click(function() {
          $('html,body').animate({
              scrollTop: $(".itg_featured-artical").offset().top},
              'slow');
         });


  
      // Full width banner js

       $('.itg_slider_banner').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              arrows: true,
            });
		
 });
 
    

